var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.093,
    height: 15.093,
    viewBox: "0 0 15.093 15.093",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.5 -3.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.138,27.864H5.955A2.458,2.458,0,0,1,3.5,25.41V22.5a1,1,0,0,1,2,0v2.91a.455.455,0,0,0,.455.455H16.138a.455.455,0,0,0,.455-.455V22.5a1,1,0,0,1,2,0v2.91A2.458,2.458,0,0,1,16.138,27.864Z",
    transform: "translate(0 -9.271)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.137,19.637a1,1,0,0,1-.707-.293L9.793,15.707a1,1,0,0,1,1.414-1.414l2.93,2.93,2.93-2.93a1,1,0,0,1,1.414,1.414l-3.637,3.637A1,1,0,0,1,14.137,19.637Z",
    transform: "translate(-3.09 -5.408)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,14.229a1,1,0,0,1-1-1V4.5a1,1,0,0,1,2,0v8.729A1,1,0,0,1,18,14.229Z",
    transform: "translate(-6.953)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.6ed8601684e62cf419852ec4aeb78756.svg";
export { ForwardRef as ReactComponent };